import { render } from "./PreEventoSection.vue?vue&type=template&id=c665e418&ts=true"
import script from "./PreEventoSection.vue?vue&type=script&lang=ts"
export * from "./PreEventoSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__